export default class LocationWalkinsFull extends HTMLElement {
  constructor() {
    super();
    this.walkins = [];
    this.showContainer = true;
    this.isMobile = false;
    this.uniqueId = "walkins-" + Math.random().toString(36).substring(2, 9);
    this.title = "Walk-in Schedule";
    this.extraText = "";
    this.mobileClasses = "";
  }

  connectedCallback() {
    const location = this.getAttribute("location");
    this.isMobile = this.getAttribute("ismobile");

    if (this.isMobile) {
      this.showContainer = false;
      this.title = "Today's Walk-In Hours";
      this.mobileClasses = "bat__faq--container";
    }

    fetch(`/wp-json/badaxe/v1/walkins/${location}`, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
      cache: 'no-store'
    })
      .then((response) => response.json())
      .then((data) => {
        if (location.toLowerCase() == 'nashville') {
          data = [
            {
              day: "Monday",
              text: null,
              times: [
                '<span class="text-center flex-1">03:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">09:00 PM</span>',
              ],
            },
            {
              day: "Tuesday",
              text: null,
              times: [
                '<span class="text-center flex-1">03:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">09:00 PM</span>',
              ],
            },
            {
              day: "Wednesday",
              text: null,
              times: [
                '<span class="text-center flex-1">03:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">09:00 PM</span>',
              ],
            },
            {
              day: "Thursday",
              text: null,
              times: [
                '<span class="text-center flex-1">03:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">09:00 PM</span>',
              ],
            },
            {
              day: "Friday",
              text: null,
              times: [
                '<span class="text-center flex-1">11:00 AM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">10:00 PM</span>',
              ],
            },
            {
              day: "Saturday",
              text: null,
              times: [
                '<span class="text-center flex-1">11:00 AM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">10:00 PM</span>',
              ],
            },
            {
              day: "Sunday",
              text: null,
              times: [
                '<span class="text-center flex-1">12:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">07:00 PM</span>',
              ],
            },
          ];
        }

        if (location.toLowerCase() == 'waldorf') {
          data = [
            {
              day: "Monday",
              text: null,
              times: ['<span class="text-center">No Walk-ins</span>'],
            },
            {
              day: "Tuesday",
              text: null,
              times: ['<span class="text-center">No Walk-ins</span>'],
            },
            {
              day: "Wednesday",
              text: null,
              times: [
                '<span class="text-center flex-1">04:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">09:00 PM</span>',
              ],
            },
            {
              day: "Thursday",
              text: null,
              times: [
                '<span class="text-center flex-1">04:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">09:00 PM</span>',
              ],
            },
            {
              day: "Friday",
              text: null,
              times: [
                '<span class="text-center flex-1">12:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">11:00 PM</span>',
              ],
            },
            {
              day: "Saturday",
              text: null,
              times: [
                '<span class="text-center flex-1">12:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">11:00 PM</span>',
              ],
            },
            {
              day: "Sunday",
              text: null,
              times: [
                '<span class="text-center flex-1">12:00 PM</span><span class="w-2 text-center">-</span><span class="text-center flex-1">05:00 PM</span>',
              ],
            },
          ];
        }
        this.walkins = data;
        if (this.isMobile) {
          this.walkins.forEach((info) => {
            if (info.day.toLowerCase() === "today") {
              this.extraText = info.times.length > 0 ? info.times[0] : "";
            }
          });
        }
        this.render();
      });
  }

  render() {
    this.innerHTML = "";

    const container = document.createElement("div");
    container.className = "";
    container.innerHTML = `
    <div id="${this.uniqueId}-container" class="${this.mobileClasses + " "}rounded-lg border-2 border-gray-400 w-full shadow-md overflow-hidden ${this.showContainer ? "min-h-walkins h-96" : "h-10"}">
        <div id="${this.uniqueId}-header" class="cursor-pointer bg-gray-200 pt-3 pr-2 pb-2 pl-2 md:pt-2 md:pr-2 md:pb-2 md:pl-2 uppercase text-sm md:text-base relative md:text-black">
            <div class="text-black md:text-black text-center font-semibold relative overflow-hidden">${this.title}
                <span
                    id="last-call-id"
                    class="text-2xs absolute right-10 sm:right-3 -bottom-4 text-brand capitalize px-2 bg-gray-200 rounded-b-lg">
                    Last Call
                </span>
                <span class="text-black text-xs font-normal pl-2">${this.extraText}</span>
            </div>
        </div>
        <div class="block p-0 md:p-4 h-full overflow-hidden">
            <div class="text-1.5xs text-center my-2 w-full bg-red">We axe inflation. Walk-in and try Bad Axe for as los as $19.99/person.</div>
            <ul>
            ${this.walkins.map((walkin) => {
      return `<li class="flex flex-row py-1 text-sm">
                      <div class="w-28 text-right pr-2 flex flex-col items-end justify-center">${walkin.day}</div>
                      <div class="flex-1 pl-2 text-sm flex flex-col items-center justify-center">
                          <div class="text-xs w-full text-right flex flex-col items-center justify-center">
                              ${typeof walkin.times === "string"
          ? `<span class="">${walkin.times}</span>`
          : walkin.times
            .map(
              (time) =>
                `<div class="text-xs w-full text-right flex flex-row items-center justify-center">${time}</div>`
            )
            .join("")
        }
                          </div>
                      </div>
                    </li>`;
    })
        .join("")}
            </ul>
          <div class="text-1.5xs text-center my-2 w-full bg-red bg-yellow-highlight mt-12 pt-2 pb-1 px-2">Start a walk-in session anytime before last call. Our Walk-In schedule is subject to change. Call us before you head over!</div>
        </div>
    </div>
    `;

    this.appendChild(container);

    this._addEventListeners();
  }

  _addEventListeners() {
    const btn = this.querySelector(`#${this.uniqueId}-header`);
    const containerEl = this.querySelector(`#${this.uniqueId}-container`);
    if (this.isMobile) {
      btn.addEventListener("click", function() {
        this.showContainer = !this.showContainer;
        containerEl.classList.toggle("h-10");
        containerEl.classList.toggle("min-h-walkins");
        containerEl.classList.toggle("bat__faq--container-active");
      });
    }
  }
}
